<script lang="ts">
    import route from "@/Util/routes";
    import { Accordion } from "@/Common";
    import { createSectionSave } from "@/Util/utils";
    import { type CalendarSettings } from "@/Common/constants";
    import { RadioGroup, RadioGroupItem } from "@/lib/components/ui/radio-group";
    import Label from "@/lib/components/ui/label/label.svelte";

    export let alwaysOpen = false
    export let cal_settings: CalendarSettings
    let classNames = "";
    export { classNames as class };

    // let { userParams } = getContext<MyFitnessStores>('myFitness')
    // let { weather, trainingMedians } = getContext<MedianAndWeatherStores>('medianAndWeather')

    function getBody(){
        return {
            use_moving_time: cal_settings.use_moving_time,
            //crop_activities: cal_settings.crop_activities,
        }
    }
    const postCalendarSettings = route('CalendarController@saveCalendarSettings');
    // Only what has been edited is saved (createSectionSave)
    const section = createSectionSave(postCalendarSettings, getBody, "Activity Time Method could not be saved.")
    const { saved } = section
    // What the server has: taken when the settings are loaded (a new object), not as they are edited (in place). Before
    // changed below: Svelte runs these in order, and changed must compare with what was just taken
    let loaded = null
    $: if (cal_settings && cal_settings !== loaded) { loaded = cal_settings; section.markSaved() }
    // Whether it has been edited since it was loaded or last saved, for the page's Save button
    export let changed = false
    $: changed = section.isChanged($saved, cal_settings)
    export const submitHandler = section.submit
</script>

<div class={classNames}>
    <Accordion {alwaysOpen} class="py-2 px-4 border border-solid border-black/10 rounded">
        <div slot="trigger" class="text-left {alwaysOpen ? '' : 'text-slate-600'}">Activity Time Method</div>
        <div slot="content" class="px-1 py-2 twp flex flex-col">

            {#if cal_settings}
                <span class="mb-2 text-md">
                    Choose the desired method for training availability and averages:
                    <a href="https://www.baronbiosys.com/glossary/activity-time" target="_help">
                        <div class="tooltip-icon">
                            <i class="fa-regular fa-circle-question" aria-hidden="true"></i>
                        </div>
                    </a>
                </span>
                <RadioGroup bind:value={cal_settings.use_moving_time}>
                    <div class="flex items-center space-x-2">
                        <RadioGroupItem value="avg" id="moving-time-option-0"></RadioGroupItem>
                        <Label class="mb-0 font-normal" for="moving-time-option-0">Total Time</Label>
                    </div>
                    <div class="flex items-center space-x-2">
                        <RadioGroupItem value="mov" id="moving-time-option-1"></RadioGroupItem>
                        <Label class="mb-0 font-normal" for="moving-time-option-1">Moving Time</Label>
                    </div>
                    <div class="flex items-center space-x-2">
                        <RadioGroupItem value="pedal" id="moving-time-option-2"></RadioGroupItem>
                        <Label class="mb-0 font-normal" for="moving-time-option-2">Pedaling Time</Label>
                    </div>
                </RadioGroup>
            {:else}
                <div class="text-slate-600 text-center">Loading...</div>
            {/if}

        </div>
    </Accordion>
</div>

<style>
    .yellow-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        position: absolute;
        top: 3px;
        right: calc(50% - 10px);
        background-color: rgb(255, 167, 0);
    }

    .this-grid {
        display: grid;
        grid-template-columns: max-content auto max-content;
        grid-auto-flow: row;
        gap: 0.25rem;
        align-items: center;
    }
</style>